import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedApiService } from '../../../../shared/service/util.service';
import { PlaylistsModel } from '../Model/school.model';

@Injectable({
  providedIn: 'root'
})
export class SchoolService {

  private SharedApiService = inject(SharedApiService)


  getPlaylists(): Observable<{ value: PlaylistsModel[], succeeded: boolean }> {
    return this.SharedApiService.getAll('EducationCourses/GetPlaylistsLookup');
  }

  getTags(): Observable<{ value: PlaylistsModel[], succeeded: boolean }> {
    return this.SharedApiService.getAll('EducationCourses/GetTagsLookup');
  }

  getYears(playlistId: number): Observable<{ value: number[], succeeded: boolean }> {
    return this.SharedApiService.getAll(`EducationCoursesVideo/GetYearsLookup?playlistId=${playlistId}`);
  }

  getVideos(filter: any) {
    return this.SharedApiService.getWithFilter('EducationCoursesVideo/GetVideos', filter);
  }

}
